module.exports = __webpack_public_path__ + "static/media/background-subscription.9506ef3e.png";